import uniqueId from 'lodash/uniqueId'
import { useEffect, useRef } from 'react'
// import { modalService } from './modalService'

interface UseModalBackButtonProps {
  open: boolean
  onClose: () => void
}

export const useModalBackButton = ({
  open,
  onClose,
}: UseModalBackButtonProps): void => {
  const idRef = useRef(uniqueId('modal-'))

  const onCloseRef = useRef(onClose)

  useEffect(() => {
    onCloseRef.current = onClose
  }, [onClose])

  useEffect(() => {
    const id = idRef.current
    if (open) {
      // modalService.add(id, onCloseRef.current)
    } else {
      // modalService.remove(id)
    }
  }, [open])

  useEffect(() => {
    const id = idRef.current
    return () => {
      // modalService.remove(id)
    }
  }, [])
}
